import { ForceDirectedGraphLink } from '../models/force-directed-graph-link';
import { ForceDirectedGraphNode } from '../models/force-directed-graph-node';

export function isForceLink(element: ForceDirectedGraphNode<any> | ForceDirectedGraphLink<any> | null) {
    return element && element.hasOwnProperty("source")
}